import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FinYear } from '../models/finyear';

@Injectable({
  providedIn: 'root'
})
export class FinYearService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'finyear/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllFinYear(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllFinYears?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewFinYear(FinYearID?: string): Observable<Array<FinYear>> {
      return this.httpService.get(this.apiEndpoint + '/viewFinYear/' + (FinYearID ? FinYearID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveFinYear(finyears: FinYear): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveFinYear/', finyears).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteFinYear(FinYearID?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteFinYear/' + (FinYearID ? FinYearID : '00000000-0000-0000-0000-000000000000'), FinYearID).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(FinYearID?: string,FinYearCode?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?FinYearCode=' + (FinYearCode ? FinYearCode : '')+ '&FinYearID=' + (FinYearID ? FinYearID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    } 
  
  }

